import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { from, of } from 'rxjs';


@Injectable()
export class LoadingService {

  constructor(public loadingController: LoadingController) { }
  loading: HTMLIonLoadingElement;
  isDisplayed = false;
  showLoading() {
    // console.log('counter ', this.counter)
    if (this.isDisplayed) {
      return of(this.loading);
    }
    this.isDisplayed = true;
    return from(
      this.loadingController.create({
        cssClass: 'custom-loader',
        spinner: null,

      }).then(async ldr => { 
        this.loading = ldr; 
        await ldr.present(); 
        return ldr; 
      }));
  }

  async hideLoading(loader: HTMLIonLoadingElement) {
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
      this.isDisplayed = false;
    }
  }

  // Force-dismiss any active loader. Used as a safety net on pages where a
  // stuck loader from an upstream flow (e.g. cancelled getUserInfoAction)
  // would otherwise block user interaction. No-op when nothing is showing,
  // so it does not perturb modals/inputs on pages without a leaked loader.
  async dismissAll() {
    if (!this.isDisplayed && !this.loading) {
      return;
    }
    try {
      let top = await this.loadingController.getTop();
      while (top) {
        await top.dismiss();
        top = await this.loadingController.getTop();
      }
    } catch {
      // getTop/dismiss on an already-gone overlay can throw — ignore
    }
    this.loading = null;
    this.isDisplayed = false;
  }
}